module.exports = __webpack_public_path__ + "img/private_event_plate1.eef09980.jpg";